module.exports = __webpack_public_path__ + "static/desktop/img/Instagram-logo.57d71316.png";